import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import NotificationFactory  from "../../../factories/NotificationFactory";
import { removeNotification, setNotification, validateNotification } from "./actions";
import { INotification } from "./types";
import NotificationValidator from "../../../validators/notification/NotificationValidator";

const getFlashMessages = (flashMessages: INotification[]): INotification[] => {
  return flashMessages.map((flashMessage: any) => {
    return NotificationFactory.create(flashMessage);
  });
};

const processingNotificationMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  if (action.type.includes(ActionTypes.NOTIFICATION.GET)) {
    next(setNotification(getFlashMessages(action.payload.flashMessages), action.meta.entity));
  }

  if (action.type.includes(ActionTypes.NOTIFICATION.REMOVE)) {
    next(removeNotification(action.payload.notificationId));
  }

  if (action.type.includes(ActionTypes.NOTIFICATION.CREATE_ERROR)) {
    next(validateNotification(action.payload.errorResponse, action.meta.entity));
  }
};

const notificationValidator: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => async (action: AnyAction) => {
  next(action);

  if (action.type.includes(ActionTypes.NOTIFICATION.VALIDATE_NOTIFICATION)) {
    try {
      const isValid = await NotificationValidator.validate(action.payload.errorResponse);

      if (isValid) {
        const notifications: INotification[] = action.payload.errorResponse.session.flashMessages.map((flashMessage: any) => {
          return NotificationFactory.create(flashMessage);
        });

        return next(setNotification(notifications, action.meta.entity));
      }
      return next(setNotification([NotificationFactory.createFromErrorResponse(action.payload.errorResponse)], action.meta.entity));
    } catch (error) {
      console.error("Validation failed:", error);
      return next(setNotification([NotificationFactory.createFromErrorResponse(action.payload.errorResponse)], action.meta.entity));
    }
  }
};


export const notificationMiddleware =  [processingNotificationMiddleware, notificationValidator];
